import React, { Component } from "react";
import LachakToranjRug from "./rugTemplates/lachakToranjRug";
import AfshanRug from "./rugTemplates/afshanRug";
import KheshtiRug from "./rugTemplates/kheshtiRug";
import RugColors from "./filters/colors";
import ModernRug from "./rugTemplates/modernRug";
import YourPicrureRug from "./rugTemplates/yourPicrureRug";

export default class CarpetBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rotate: false
    };
  }

  rotateHandler = evt => {
    this.setState({ rotate: !this.state.rotate });
  };

  render() {
    return (
      <div
        className={`min-height-for-scroll ${this.state.rotate ? "active" : " "
          }`}
      >

        <div className="body-filters">
          {/* color filter */}
          <RugColors
            selectedColors={this.props.globalState.colors}
            changeHandler={this.props.filterChangeHandler}
          />
          {/* ${this.state.rotate ? "rotation-90-btn" : "rotation-90-btn-reverse"} */}
          <div
            className={`body-button `}
          >
            <button className="change-position" onClick={this.rotateHandler}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.75 22.75H7.25C3.1 22.75 1.25 20.9 1.25 16.75V12.25C1.25 8.1 3.1 6.25 7.25 6.25H11.75C15.9 6.25 17.75 8.1 17.75 12.25V16.75C17.75 20.9 15.9 22.75 11.75 22.75ZM7.25 7.75C3.93 7.75 2.75 8.93 2.75 12.25V16.75C2.75 20.07 3.93 21.25 7.25 21.25H11.75C15.07 21.25 16.25 20.07 16.25 16.75V12.25C16.25 8.93 15.07 7.75 11.75 7.75H7.25Z" fill="#353D57" />
                <path d="M22.0004 9.75C21.5904 9.75 21.2504 9.41 21.2504 9C21.2504 6.04 19.1904 3.56 16.4204 2.91L16.6904 3.36C16.9004 3.72 16.7904 4.18 16.4304 4.39C16.0704 4.6 15.6104 4.49 15.4004 4.13L14.3504 2.38C14.2104 2.15 14.2104 1.86 14.3404 1.63C14.4804 1.4 14.7304 1.25 15.0004 1.25C19.2704 1.25 22.7504 4.73 22.7504 9C22.7504 9.41 22.4104 9.75 22.0004 9.75Z" fill="#353D57" />
              </svg>

            </button>
            <button
              className="clear-background"
              onClick={this.props.partsClearHandler}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#353D57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <g opacity="0.4">
                  <path d="M6.98994 15.08L8.92993 17.02C9.56993 17.66 10.6299 17.66 11.2699 17.02L17.0199 11.27C17.6599 10.63 17.6599 9.57 17.0199 8.93L15.0799 6.99001C14.4399 6.35001 13.3799 6.35001 12.7399 6.99001L6.98994 12.74C6.33994 13.38 6.33994 14.43 6.98994 15.08Z" stroke="#353D57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.31006 10.4199L13.5801 14.6899" stroke="#353D57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>

            </button>
          </div>
        </div>
        
        <div className="row rotation-mobile-time">
          {/* be div payin baraye charkhesh class rotation-90 bede  */}

          <div
            className={`text-center before-body-carpet relative m-auto ${this.state.rotate ? "rotation-90" : "rotation-90-reverse"}`}
          >

            <div className="body-carpet">
              {/* Afshan */}
              <AfshanRug
                background={
                  this.props.globalState.afshanSelectedParts.background
                }
                border={this.props.globalState.afshanSelectedParts.border}
                show={this.props.globalState.activeCarpetType === "afshan"}
              />
              {/* Lachak-Toranj */}
              <LachakToranjRug
                background={
                  this.props.globalState.lachakToranjSelectedParts.background
                }
                border={this.props.globalState.lachakToranjSelectedParts.border}
                corner={this.props.globalState.lachakToranjSelectedParts.corner}
                toranj={this.props.globalState.lachakToranjSelectedParts.toranj}
                show={
                  this.props.globalState.activeCarpetType === "lachak-toranj"
                }
              />
              {/* Modern */}
              <ModernRug
                background={
                  this.props.globalState.modernSelectedParts.background
                }
                title={this.props.globalState.modernSelectedParts.title}
                show={this.props.globalState.activeCarpetType === "modern"}
              />
              {/* Kheshti */}
              <KheshtiRug
                background={
                  this.props.globalState.kheshtiSelectedParts.background
                }
                tile={this.props.globalState.kheshtiSelectedParts.tile}
                border={this.props.globalState.kheshtiSelectedParts.border}
                show={this.props.globalState.activeCarpetType === "kheshti"}
              />
              {/* Kheshti */}
              <YourPicrureRug
                background={
                  this.props.globalState.yourPicSelectedParts.background
                }
                title={this.props.globalState.yourPicSelectedParts.title}
                show={this.props.globalState.activeCarpetType === "your_picture"}
              />
            </div>
            {/* be div payin baraye charkhesh class rotation-90-btn bede  */}
          </div>
        </div>

        <div className={`w-100 body-button-mobile`}>
          <button className="change-position" onClick={this.rotateHandler}>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.75 22.75H7.25C3.1 22.75 1.25 20.9 1.25 16.75V12.25C1.25 8.1 3.1 6.25 7.25 6.25H11.75C15.9 6.25 17.75 8.1 17.75 12.25V16.75C17.75 20.9 15.9 22.75 11.75 22.75ZM7.25 7.75C3.93 7.75 2.75 8.93 2.75 12.25V16.75C2.75 20.07 3.93 21.25 7.25 21.25H11.75C15.07 21.25 16.25 20.07 16.25 16.75V12.25C16.25 8.93 15.07 7.75 11.75 7.75H7.25Z" fill="#353D57" />
                <path d="M22.0004 9.75C21.5904 9.75 21.2504 9.41 21.2504 9C21.2504 6.04 19.1904 3.56 16.4204 2.91L16.6904 3.36C16.9004 3.72 16.7904 4.18 16.4304 4.39C16.0704 4.6 15.6104 4.49 15.4004 4.13L14.3504 2.38C14.2104 2.15 14.2104 1.86 14.3404 1.63C14.4804 1.4 14.7304 1.25 15.0004 1.25C19.2704 1.25 22.7504 4.73 22.7504 9C22.7504 9.41 22.4104 9.75 22.0004 9.75Z" fill="#353D57" />
              </svg>
          </button>
          <button
            className="clear-background"
            onClick={this.props.partsClearHandler}
          >
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#353D57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <g opacity="0.4">
                  <path d="M6.98994 15.08L8.92993 17.02C9.56993 17.66 10.6299 17.66 11.2699 17.02L17.0199 11.27C17.6599 10.63 17.6599 9.57 17.0199 8.93L15.0799 6.99001C14.4399 6.35001 13.3799 6.35001 12.7399 6.99001L6.98994 12.74C6.33994 13.38 6.33994 14.43 6.98994 15.08Z" stroke="#353D57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.31006 10.4199L13.5801 14.6899" stroke="#353D57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
          </button>
        </div>
      </div>
    );
  }
}
